import React from "react";

const CalendarIcon = () => {
  return (
    <>
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path
          id="Path_2541"
          data-name="Path 2541"
          d="M19,4H17V3a1,1,0,0,0-2,0V4H9V3A1,1,0,0,0,7,3V4H5A3,3,0,0,0,2,7V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V7a3,3,0,0,0-3-3m1,15a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V12H20Zm0-9H4V7A1,1,0,0,1,5,6H7V7A1,1,0,0,0,9,7V6h6V7a1,1,0,0,0,2,0V6h2a1,1,0,0,1,1,1Z"
          transform="translate(-2 -2)"
        />
      </svg>
    </>
  );
};

export default CalendarIcon;
